import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  num: '1',
  title: 'Inclusione Facile (BES/DSA)',
  desc: 'Mappe, PDP template e materiali compensatori pronti per ogni unità. Zero stress con la Legge 170/2010.'
}, {
  num: '2',
  title: 'IA Generativa in Classe',
  desc: "30 prompts testati per creare verifiche, trasformare testi letterari in podcast e usare l'IA in modo etico."
}, {
  num: '3',
  title: 'Ed. Civica & Debate',
  desc: '20 unità collegate alla Costituzione + metodologia Debate. Le 33 ore obbligatorie già pianificate per te.'
}, {
  num: '4',
  title: 'Registro Veloce',
  desc: 'Griglie pronte per ClasseViva, Argo e Axios. Correzione rapida dei temi. Il tuo weekend torna ad essere tuo.'
}];
export function BonusSection() {
  return <section className="py-10 sm:py-12 px-4 relative overflow-hidden" data-id="element-29">
      <div className="absolute inset-0 bg-brand-orange/5 blur-[120px] rounded-full max-w-3xl mx-auto" data-id="element-30" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 flex flex-col items-center" data-id="element-32">
          <div className="bg-brand-orange/20 p-4 rounded-full mb-4" data-id="element-33">
            <GiftIcon className="w-10 h-10 text-brand-orange" data-id="element-34" />
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black uppercase text-brand-cream" data-id="element-35">
            4 Bonus Strategici <span className="text-brand-gold" data-id="element-36">Inclusi</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-4" data-id="element-37">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-gradient-to-br from-brand-card to-[#2a1810] border border-brand-orange/30 p-6 sm:p-8 rounded-2xl shadow-[0_0_20px_rgba(249,115,22,0.1)]" data-id="element-38">
              <div className="flex items-center gap-3 mb-4" data-id="element-39">
                <span className="text-2xl" data-id="element-40">📘</span>
                <h3 className="text-xl sm:text-2xl font-bold text-brand-gold" data-id="element-41">
                  Bonus {bonus.num} — {bonus.title}
                </h3>
              </div>
              <p className="text-gray-300 font-medium leading-relaxed" data-id="element-42">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}